import { render } from "./building_product.vue?vue&type=template&id=3fef4a95&scoped=true"
import script from "./building_product.vue?vue&type=script&lang=js"
export * from "./building_product.vue?vue&type=script&lang=js"

import "./building_product.vue?vue&type=style&index=0&id=3fef4a95&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fef4a95"]])

export default __exports__